import { SessionStorageService } from './SessionStorageService';

export * from './constants';
export * from './types';

export const sessionStorageService = new SessionStorageService();
